import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const SectionTopbarStyled = styled.nav(
  ({ theme }) => css`
    position: sticky;
    top: 0;
    z-index: 2;

    display: flex;
    align-items: center;
    gap: 0.6rem;
    height: 6.2rem;
    padding: 0.9rem 1.2rem;

    background: ${theme.colors.white};
    border-bottom: 1px solid ${theme.colors.border};
  `
);

export const TeamSelectorStyled = styled.article(
  ({ theme }) => ({ h1: theme.font('sm', 'bl') }),
  () => css`
    h1 {
      margin-bottom: 0.5rem;
    }
    label {
      margin: 0;

      span {
        font-size: 1.2rem;
        text-transform: none;
      }
    }
    input {
      margin: 0;
      + label {
        &:before {
          margin-right: 1rem !important;
        }
        padding: 0.2rem 0 !important;
      }
    }
  `
);
